<template>
  <div>
  <div class="container">
        <div class="row">
            
            <div class="col-lg-12 col-md-12 col-sm-24">
                <div class="row">&nbsp;</div>

            

              <div class="product-btn"  style="color:#111111">
                  <a  @click="navigateBack();"><i class="ion-arrow-left-c"  style="color:#111111"></i>Terug</a>
                </div>

            </div>
             <div class="col-lg-12 col-md-12 col-sm-24">
                <div class="row">&nbsp;</div>
                <div class="row">&nbsp;&nbsp;<h5 style="font-weight: bold;">Mijn afspraken</h5>
                Geef hieronder je email adres in en ontvang al je afspraken via mail.
                </div>
                
                
                <div class="contact-message pt-20 pt-sm-20">
                  <div class="row text-center">
                      <div class="col-24 contact-btn text-center">
                          <input name="email_address" placeholder="Email *" type="text" v-model="mail">    
                      </div>

                      <div class="col-24 contact-btn text-center"> 
                             <div class="product-btn" >
                                <a @click="getMyApps" v-bind:style="{ 'background-color': getColorApp, color: '#fff'}"><i class="ion-bag" ></i>Afspraken ophalen</a>
                              </div>
                      </div>  
                      
                      <div class="col-24" style="height:40px;">
                            
                      </div> 
                      <div class="row"><div class="col-24">&nbsp;</div></div>
                      <div class="row"><div class="col-24">&nbsp;</div></div>
                      <div class="row"><div class="col-24" style="height:40px;">&nbsp;</div></div>
                      <div class="row">&nbsp;&nbsp; <span style='color:#ff0000;'>{{ errormsg }}</span></div>
                  </div>
                </div>
            </div>
           
        </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import CartItem  from '../components/cart/CartItem';
  import CartCheckout from '../components/cart/CartCheckout.vue'
  import myHttpApi from "../api/myhttpapi"
  import {
    SPINNER_SHOW,
    SPINNER_HIDE,
    CLEAR_CART
  } from '../store/mutation-types'

  export default {
     metaInfo: {
        title: 'Mijn account'
    },
    name: 'product-list',
    props: ['products'],
    data () {
      return {
        cart: this.$store.state.cart,
        flgShowDet : false,
        mail : '',
        errormsg : ''
      }
    },
    components: {
        cartItem : CartItem
    },
    computed: {
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       },
      getSelectedTime () {
          return Vue.$selectedTime;
      },
      getSelectedTimeInfo () {
          return Vue.$selectedTime.TimeInfo;
      },
      getSelectedDateInfo () {
          return Vue.$selectedTime.DateInfo;
      }
    },
    mounted () {
        this.mail = "";
            
      
        if (localStorage.mail) {
          this.mail = localStorage.mail;
        }
       
    },
    methods: {
       navigate (item) {
        this.$router.push(item);
      },
      navigateBack () {
        this.navigate ("/");
      },
      showDetails () {
         this.flgShowDet = !this.flgShowDet;
      },
      getMyApps () {

          this.$store.commit(SPINNER_SHOW);
          localStorage.mail = this.mail;
          this.errormsg = '';

          const cust = {Email: this.mail}
         // const appointRec = {Customer: cust }
          myHttpApi.post( 'Account/GetMyAccount', cust)
              .then(response => {
                 var result = response.data;
                 this.$store.commit(SPINNER_HIDE);
                 if (result.ResultCode == 0)
                 {
                    
                   // this.$store.state.cart = [];
                    this.$store.commit(CLEAR_CART);
                    this.navigate ("/MyAccountSend");
                 }
                 else if (result.ResultCode > 0)
                 {
                    //alert (result.ErrorMsg);
                    this.errormsg = result.ErrorMsg;
                    this.navigate ("/MyAccount");
                 }
                
                 
              })
              .catch(error => {
                console.log(error);
                this.freePaces = [];
                alert (error);
                this.$store.commit(SPINNER_HIDE);
          });
      }
    }
  }
</script>
<style>
  .products {
    background: #F7F8FB;
    padding: 30px 0;
  }
  @media (max-width: 800px) {
      .hidesmall {
        display: none;
      }
  }
</style>



// WEBPACK FOOTER //
// src/pages/MyAccount.vue